// import WebApp from "telegram-mini-app";
// import { useUserStore } from "@/store/user";
import TonWeb from "tonweb";
/**
 * 检查给定的时间戳是否为昨天的日期
 * @param {number} timestamp - 要检查的时间戳（毫秒）
 * @return {boolean} 如果时间戳是昨天的日期则返回true，否则返回false
 */
function isYesterday(timestamp) {
  // 创建表示今天的Date对象
  const today = new Date();
  // 将today的时间设置为当天的开始（午夜）
  // setHours(hour [, min [, sec [, ms ]]])
  today.setHours(0, 0, 0, 0);

  // 创建表示昨天的Date对象
  const yesterday = new Date(today);
  // 将日期设置为前一天
  // setDate(dayOfMonth)：设置月份中的第几天，如果值超出了范围，日期会自动往前或往后调整
  yesterday.setDate(yesterday.getDate() - 1);

  // 从传入的时间戳创建Date对象
  const date = new Date(timestamp);
  // 将date的时间也设置为当天的开始，以便只比较日期而忽略时间
  date.setHours(0, 0, 0, 0);

  // 比较date和yesterday的时间戳是否相等
  // getTime()：返回自1970年1月1日以来的毫秒数
  return date.getTime() === yesterday.getTime();
}

/**
 * 设置了时间限制的本地存储方法
 * @param {string} key  存储的关键字
 * @param {string} value     需要存储的数据
 * @param {number} expirationMinutes 过期时间 分钟
 */
function setCacheV1(key, value, expirationMinutes) {
  console.log(
    "key==>",
    key,
    "value==>",
    value,
    "expirationMinutes==>",
    expirationMinutes,
  );
  key = TApp_GlobalConfig.project_id + "_" + key;
  const currentTime = new Date().getTime();
  const expirationTime = expirationMinutes
    ? currentTime + expirationMinutes * 60 * 1000
    : null;
  const data = {
    value: value,
    expirationTime: expirationTime,
  };
  localStorage.setItem(key, JSON.stringify(data));
}
/**
 * 取出有时间限制的本地存储方法
 * @param {string} key
 * @returns {null||string} value 得到的数据
 */
function getCacheV1(key) {
  console.log(key);
  key = TApp_GlobalConfig.project_id + "_" + key;
  const cachedData = localStorage.getItem(key);
  if (!cachedData) {
    return null;
  }
  const parsedData = JSON.parse(cachedData);
  const expirationTime = parsedData.expirationTime;
  if (expirationTime && new Date().getTime() > expirationTime) {
    localStorage.removeItem(key);
    return null;
  }
  return parsedData.value;
}
function removeCacheV1(key) {
  key = TApp_GlobalConfig.project_id + "_" + key;
  localStorage.removeItem(key);
}
//在谷歌环境和测试环境
function setCacheV2(key, value) {
  key = TApp_GlobalConfig.project_id + "_" + key;
  return new Promise((resolve, reject) => {
    try {
      window.Telegram.WebApp.CloudStorage.setItem(
        key,
        value,
        function (error, res) {
          if (error) {
            reject(error);
          } else {
            resolve(res || null);
          }
        },
      );
    } catch (error) {
      // 处理本地存储的情况
      localStorage.setItem(key, value);
      resolve(null);
    }
  });
}
function getCacheV2(key) {
  key = TApp_GlobalConfig.project_id + "_" + key;
  return new Promise((resolve, reject) => {
    try {
      window.Telegram.WebApp.CloudStorage.getItem(key, function (error, value) {
        if (error) {
          reject(error);
        } else {
          resolve(value || null);
        }
      });
    } catch (error) {
      // 处理本地存储的情况
      resolve(localStorage.getItem(key));
    }
  });
}
function removeCacheV2(key) {
  key = TApp_GlobalConfig.project_id + "_" + key;
  if (import.meta.env.DEV) {
    localStorage.removeItem(key);
  } else {
    window.Telegram.WebApp.CloudStorage.removeItem(key);
  }
}

// 生成 min 到 max 之间的随机整数（包括min和max）
function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// 生成 min 到 max 之间的随机小/整数（包括min和max）
function getRandomFloatInclusive(min, max) {
  // 处理小数点位数
  const minDecimalPlaces = (min.toString().split(".")[1] || []).length;
  const maxDecimalPlaces = (max.toString().split(".")[1] || []).length;

  // 计算放大倍数
  const decimalPlaces = Math.max(minDecimalPlaces, maxDecimalPlaces);
  const factor = Math.pow(10, decimalPlaces);

  // 生成随机整数并转为浮点数
  const randomInt =
    Math.floor(
      Math.random() * (Math.floor(max * factor) - Math.ceil(min * factor) + 1),
    ) + Math.ceil(min * factor);
  const randomFloat = randomInt / factor;

  return randomFloat;
}

// 生成指定位数的随机整数
function getRandomDigits(digits) {
  return (
    Math.floor(Math.random() * (9 * Math.pow(10, digits - 1))) +
    Math.pow(10, digits - 1)
  );
}

/**
 * 将金额转成带单位的金额
 * @param {'*'} num
 * @returns
 */
function formatNumber(num) {
  num = Number(num);
  if (!num) {
    return `0`;
  }
  const units = ["", "k", "m", "b", "t"];
  const unit = Math.floor(Math.log(Math.abs(num)) / Math.log(1000));
  const value = (num / Math.pow(1000, unit)).toFixed(2);
  return `${value}${units[unit]}`;
}

/**
 * 将时间戳转换为自定时间格式
 * @param {number} timestamp
 * @returns {string} 转换的时间
 */
function formatTimeFromTimestamp(seconds) {
  // 确保输入是一个非负整数
  seconds = Math.max(Math.floor(seconds), 0);

  // 计算小时、分钟和剩余秒数
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // 将每个部分转换为两位数的字符串
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");

  // 拼接时间字符串
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

function toPercentageDecimal(number) {
  // 如果数字大于1，将其转换为0到1之间的小数
  if (number > 1) {
    number = number / 100;
  }
  // 四舍五入到四位小数
  return (Math.round(number * 10000) / 10000) * 100;
}

//两数相加
function add(num1, num2) {
  const num1Digits = (num1.toString().split(".")[1] || "").length;
  const num2Digits = (num2.toString().split(".")[1] || "").length;
  const baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
}

// 判断是否ios设备
function isIOSDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(userAgent);
}

// 获取随机字符串
function getRandTxt(length, type) {
  var characters;
  if (type === 1) {
    characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  } else if (type === 2) {
    characters = "0123456789";
  } else {
    characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  }
  var result = "";
  for (var i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  return result;
}

// 文本编码
function _twa_encode(data) {
  var json_str = data;
  json_str = json_str.split("").reverse().join("");
  const encoder = new TextEncoder();
  const dataArray = encoder.encode(json_str);
  let binary = "";
  const len = dataArray.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(dataArray[i]);
  }
  var base64_str = window.btoa(binary).replace(/=/g, "");
  var strrev_str = base64_str.split("").reverse().join("");
  strrev_str = strrev_str
    .replace(/a/g, "#")
    .replace(/z/g, "a")
    .replace(/#/g, "z");
  var num = Math.floor(Math.random() * (1100 - 1000 + 1) + 1000) * 3;
  num = window.btoa(num).replace(/=/g, "").split("").reverse().join("");
  var result =
    getRandTxt(Math.floor(Math.random() * (17 - 3 + 1) + 3), 1) +
    num +
    strrev_str +
    num +
    getRandTxt(Math.floor(Math.random() * (17 - 3 + 1) + 3), 1);
  return result;
}

// 文本解码
function _twa_decode(txt) {
  var text_decode = "";
  //var _req = {};
  var _req = "";
  var i;
  for (i = 999; i < 1101; i++) {
    var temp_num = btoa(i * 3);
    temp_num = temp_num.replace(/=/g, "").split("").reverse().join("");
    var temp_reg = new RegExp(temp_num + "[\\s\\S]*?" + temp_num, "g");
    try {
      var temp_match = txt.match(temp_reg).toString();
      text_decode = temp_match.replace(new RegExp(temp_num, "g"), "");
      break;
    } catch (err) {}
  }
  try {
    text_decode = text_decode
      .replace(/z/g, "#")
      .replace(/a/g, "z")
      .replace(/#/g, "a");
    text_decode = text_decode.split("").reverse().join("");
    text_decode = atob(text_decode);
    text_decode = text_decode.split("").reverse().join("");
    _req = text_decode;
    //_req = JSON.parse(text_decode);
  } catch (err) {}
  return _req;
}

//设置存储
function setLocalStorage(key, value) {
  if (key == "google_b" || key == "google_p") {
    value = _twa_encode(value);
  }
  localStorage.setItem(`${TApp_GlobalConfig.project_id}_${key}`, value);
}
//获取存储
function getLocalStorage(key, raw = false) {
  let value = localStorage.getItem(`${TApp_GlobalConfig.project_id}_${key}`);
  if ((key == "google_b" || key == "google_p") && !raw) {
    try {
      value = _twa_decode(value);
    } catch (error) {
      console.log(error);
    }
  }
  return value;
}
//删除存储
function removeLocalStorage(key) {
  localStorage.removeItem(`${TApp_GlobalConfig.project_id}_${key}`);
}

// 用户当前环境是否支持某个版本
function isSupportedVersion(requiredVersion) {
  const currentVersion = window.Telegram.WebApp.version;
  const currentParts = currentVersion.split(".").map(Number);
  const requiredParts = requiredVersion.split(".").map(Number);
  for (
    let i = 0;
    i < Math.max(currentParts.length, requiredParts.length);
    i++
  ) {
    const currentPart = currentParts[i] || 0;
    const requiredPart = requiredParts[i] || 0;
    if (currentPart > requiredPart) {
      return true;
    } else if (currentPart < requiredPart) {
      return false;
    }
  }
  return true;
}

/* 震动触感 中度 */
function appHapticFeedback() {
  if (isSupportedVersion("6.0")) {
    window.Telegram.WebApp.HapticFeedback.impactOccurred("medium");
  }
}

/* 震动触感 轻度 */
function appHapticFeedbackSoft() {
  if (isSupportedVersion("6.0")) {
    window.Telegram.WebApp.HapticFeedback.impactOccurred("soft");
  }
}

// 获取当前日期
function getCurrentDate() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
}

// 将数字格式化为千分位展示，保留原始小数位
function addCommasToNumber(number) {
  if (number === null || number === undefined || number === "") {
    return "";
  }
  const text = String(number).replace(/\uFF0C/g, ",").replace(/,/g, "");
  if (!/^-?\d+(\.\d+)?$/.test(text)) {
    return String(number);
  }
  const [integer, decimal] = text.split(".");
  const sign = integer.startsWith("-") ? "-" : "";
  const intText = sign ? integer.slice(1) : integer;
  const formattedInteger = intText.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${sign}${formattedInteger}${decimal !== undefined ? `.${decimal}` : ""}`.replace(/\uFF0C/g, ",");
}

// 打开链接（兼容外部/TG链接）
function openUrl(url) {
  if (location.hostname != "localhost" && location.hostname != "127.0.0.1") {
    if (url) {
      if (url.includes("//t.me")) {
        window.Telegram.WebApp.openTelegramLink(url);
      } else {
        window.Telegram.WebApp.openLink(url);
      }
    }
  }
}

// 成功弹窗
function toastSuccess($swal, text) {
  $swal.fire({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 2000,
    title: text,
    background: "#1a1a1a",
    color: "#ffffff",
    customClass: {
      popup: "custom-toast-popup",
      title: "custom-toast-title",
    },
    showClass: {
      backdrop: "empty",
      icon: "empty",
    },
  });
}

// 失败弹窗
function toastFail($swal, text) {
  $swal.fire({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 2000,
    title: text,
    background: "#1a1a1a",
    color: "#ffffff",
    customClass: {
      popup: "custom-toast-popup",
      title: "custom-toast-title",
    },
    showClass: {
      backdrop: "empty",
      icon: "empty",
    },
  });
}

// 添加全局样式
const style = document.createElement("style");
style.textContent = `
  .custom-toast-popup {
    border-radius: 2vw !important;
    box-shadow: 0 0.4vw 2vw rgba(0, 0, 0, 0.5) !important;
    border: 1px solid #333333 !important;
    padding: 3vw !important;
  }

  .custom-toast-title {
    font-size: 3.8vw !important;
    font-weight: 500 !important;
    color: #ffffff !important;
  }

  .swal2-popup {
    background-color: #1a1a1a !important;
    color: #ffffff !important;
  }

  .swal2-title {
    color: #ffffff !important;
  }

  .swal2-html-container {
    color: #888888 !important;
  }

  .swal2-confirm {
    background-color: var(--theme-color) !important;
    color: #000000 !important;
    font-weight: bold !important;
    border-radius: 1.5vw !important;
    padding: 2vw 4vw !important;
    font-size: 3.8vw !important;
  }

  .swal2-cancel {
    background-color: #333333 !important;
    color: #ffffff !important;
    font-weight: bold !important;
    border-radius: 1.5vw !important;
    padding: 2vw 4vw !important;
    font-size: 3.8vw !important;
  }
`;
document.head.appendChild(style);

// 钱包地址缩写
function truncateString(str) {
  if (typeof str != "string") {
    return str;
  }
  if (str.length <= 12) {
    return str;
  }
  return str.slice(0, 5) + "..." + str.slice(-4);
}

// 预先加载图片素材
const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve();
    img.onerror = () => reject(new Error("Image failed to load"));
  });
};

/**
 * 处理矿工数据：解析JSON、过滤过期项、计算总和、重新生成JSON
 * @param {string} minerJson - 矿工数据的JSON字符串
 * @returns {Object} 包含处理结果的对象
 */
function processMinerData(miners) {
  try {
    // 解析JSON字符串为数组
    //const miners = JSON.parse(minerJson);
    // 获取当前时间戳
    const currentTimestamp = Math.floor(Date.now() / 1000);
    // 过滤出未过期的矿工
    const validMiners = miners.filter(
      (miner) => miner.expires > currentTimestamp,
    );
    // 计算总和
    const totals = validMiners.reduce(
      (acc, miner) => {
        return {
          totalProfit: acc.totalProfit + miner.profit,
          totalHashrate: acc.totalHashrate + miner.hashrate,
        };
      },
      { totalProfit: 0, totalHashrate: 0 },
    );
    // 检查是否有过期项
    const hasExpired = miners.length !== validMiners.length;
    // 如果有过期项，生成新的JSON字符串
    const newJson = hasExpired ? JSON.stringify(validMiners) : "";
    return {
      totals,
      hasExpired,
      newJson,
    };
  } catch (error) {
    throw new Error(`${error.message}`);
  }
}

// 计算可领取的数量
function calculateClaimAmount(totalYield, claimLimitNano) {
  // 转换为 BigInt 以处理可能的大数
  const total = BigInt(totalYield);
  const limit = BigInt(claimLimitNano);

  // 如果总产出小于最低领取限制，返回不可领取
  if (total < limit) {
    return {
      canClaim: false,
      claimableAmount: "0",
      remainder: totalYield,
      times: 0,
    };
  }

  // 计算可领取的份数（向下取整）
  const times = total / limit;
  // 计算可领取数量（份数 * 最低限制）
  const claimableAmount = times * limit;
  // 计算余数
  const remainder = total - claimableAmount;

  return {
    canClaim: true,
    claimableAmount: claimableAmount.toString(),
    remainder: remainder.toString(),
    times: Number(times),
  };
}

// 格式化时间戳
function formatTimestamp(timestamp) {
  // 将时间戳转换为毫秒
  const date = new Date(timestamp * 1000);

  // 获取各个部分
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  // 返回格式化的字符串
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

//延迟等待
function delayAwait(min, max) {
  const delayTime = Math.floor(Math.random() * (max - min + 1)) + min;
  return new Promise((resolve) => setTimeout(resolve, delayTime));
}

//是不是移动设备
function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
}

// 是不是在白名单
function isUserInWhitelist(userId, whitelist) {
  // 使用正则表达式匹配中文和英文逗号，将白名单字符串转换为数组
  const whitelistArray = whitelist.split(/[,，]/).map((id) => id.trim());
  // 判断 userid 是否在白名单数组中
  return whitelistArray.includes(userId);
}

/**
 * 检查状态
 * @param {function} back - 请求函数
 * @param {object} back_data - 请求参数
 * @param {number} maxAwaitRetries - 支付等待状态最大重试次数
 * @param {number} maxErrorRetries - 请求失败最大连续重试次数
 * @param {number} interval - 重试间隔时间(毫秒)
 * @returns {Promise<{success: boolean, message: string}>}
 */
const checkPaymentStatus = async ({
  back,
  back_data,
  maxAwaitRetries = 3,
  maxErrorRetries = 3,
  interval = 10000,
}) => {
  let awaitRetryCount = 0; // 支付等待状态的重试次数
  let errorRetryCount = 0; // 连续失败/异常的重试次数

  const check = async () => {
    try {
      const checkRes = await back(back_data);

      if (checkRes.code !== 200) {
        throw new Error("检查订单状态失败");
      }

      // 请求成功后重置错误重试计数
      errorRetryCount = 0;

      switch (checkRes.data) {
        case "success":
          return { success: true, message: "支付成功" };
        case "wait":
          if (awaitRetryCount >= maxAwaitRetries) {
            return { success: false, message: "支付超时，请重试" };
          }
          awaitRetryCount++;
          await new Promise((resolve) => setTimeout(resolve, interval));
          return check();
        default:
          return { success: false, message: "支付失败，请后再试" };
      }
    } catch (error) {
      errorRetryCount++;

      if (errorRetryCount >= maxErrorRetries) {
        return {
          success: false,
          message: "系统异常，请稍后再试",
        };
      }

      await new Promise((resolve) => setTimeout(resolve, interval));
      return check();
    }
  };

  return check();
};

const DecimalUtils = {
  PRECISION: 8, // 统一精度配置

  // 将字符串或数字转换为数字类型
  toNumber(value, defaultValue = "0") {
    const num = Number(value || defaultValue);
    return Number.isFinite(num) ? num : 0;
  },

  // 精确加法
  add(num1, num2) {
    const factor = Math.pow(10, this.PRECISION);
    const n1 = Math.round(this.toNumber(num1) * factor);
    const n2 = Math.round(this.toNumber(num2) * factor);
    return (n1 + n2) / factor;
  },

  // 精确减法
  subtract(num1, num2) {
    const factor = Math.pow(10, this.PRECISION);
    const n1 = Math.round(this.toNumber(num1) * factor);
    const n2 = Math.round(this.toNumber(num2) * factor);
    return (n1 - n2) / factor;
  },

  // 精确乘法
  multiply(num1, num2) {
    const n1 = this.toNumber(num1);
    const n2 = this.toNumber(num2);
    const result = n1 * n2;
    // 四舍五入到指定精度
    return Number(result.toFixed(this.PRECISION));
  },

  // 精确除法
  divide(num1, num2) {
    const n1 = this.toNumber(num1);
    const n2 = this.toNumber(num2);

    // 处理除数为0的情况
    if (n2 === 0) {
      throw new Error("除数不能为0");
    }

    const result = n1 / n2;
    // 四舍五入到指定精度
    return Number(result.toFixed(this.PRECISION));
  },

  // 格式化数字为字符串
  toString(num) {
    return this.toNumber(num).toString();
  },
};

/**
 *  用户id编码方法
 * @param {number} num  用户id
 * @returns {string}
 */
function base62Encode(num) {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const base = chars.length;
  let encoded = "";
  while (num > 0) {
    encoded = chars[num % base] + encoded;
    num = Math.floor(num / base);
  }
  return encoded || "0";
}
function readClipboardText(callback) {
  try {
    // 检查 Telegram WebApp 是否可用
    if (!window.Telegram || !window.Telegram.WebApp) {
      throw new Error("Telegram WebApp is not available");
    }

    // 检查是否支持剪贴板API
    if (!window.Telegram.WebApp.readTextFromClipboard) {
      throw new Error("Clipboard API is not supported (requires Bot API 6.4+)");
    }

    // 注册剪贴板事件监听
    window.Telegram.WebApp.onEvent("clipboardTextReceived", (text) => {
      if (typeof callback === "function") {
        callback(text);
      }
    });

    // 调用读取剪贴板方法
    window.Telegram.WebApp.readTextFromClipboard(callback);
  } catch (error) {
    console.error("Clipboard read error:", error);
    if (typeof callback === "function") {
      callback(null, error);
    }
  }
}
function addressFun(address) {
  console.log(address);
  if (address.includes("0:") || address.includes("0x")) {
    const addressUtils = TonWeb.utils.Address;
    const addressRaw = new addressUtils(address);
    const walletAdd = addressRaw.toString(true);
    console.log(walletAdd);
    return walletAdd;
  }
  return address;
}
/**
 * 获取币价格
 * @param {string} params
 * @returns
 */
async function getCoinPrice(params) {
  const coin_name = params.toUpperCase();
  if (coin_name == "USDT" || coin_name == "USDC") {
    return 1;
  }
  let price = 0;
  try {
    // 获取币的价格
    await fetch(
      `https://api2.binance.com/api/v3/ticker/price?symbol=${coin_name}USDT`,
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        price = data.price;
      });
  } catch (error) {
    console.error(error);
  }
  if (price > 0) {
    return price;
  }
  try {
    await fetch(
      `https://www.okx.com/api/v5/market/ticker?instId=${coin_name}-USDT`,
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        price = data.data[0].last;
      });
  } catch (error) {
    console.error(error);
  }
  if (price > 0) {
    return price;
  }
  try {
    await fetch(
      `https://api.bitget.com/api/v2/spot/market/tickers?symbol=${coin_name}USDT`,
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        price = data.data[0].lastPr;
      });
  } catch (error) {
    console.error(error);
  }
  return price;
}
const getUrl = (invoice_id, cache_key) => {
  // 语言
  const lang = getLocalStorage("nowLanguage") || "en";
  let url = "";
  // 是否全屏模式
  let is_full_screen = false;
  if (isSupportedVersion("8.0") && isMobileDevice()) {
    is_full_screen = true;
  }
  // 当前时间戳
  const timestamp = Date.now();
  // 支付页面url
  let payment_url = `${window.location.origin}/payment`; //线上版本
  if (location.hostname == "localhost" || location.hostname == "127.0.0.1") {
    payment_url = `http://localhost:5170/`; //本地版本
  }
  // 附带参数的支付链接
  url = `${payment_url}?url=${encodeURIComponent(
    window.location.href,
  )}&is_full_screen=${is_full_screen}&cache_key=${cache_key}&timestamp=${timestamp}&theme=dark&version=v2#/invoice/${lang}/${invoice_id}`;
  return url;
};
function trimTrailingZeros(value) {
  // 转为字符串
  let str = String(value);

  // 如果不包含小数点，直接返回
  if (!str.includes(".")) return str;

  // 去掉末尾的 0
  str = str.replace(/0+$/, "");

  // 如果小数点后全是 0，也去掉小数点
  if (str.endsWith(".")) {
    str = str.slice(0, -1);
  }

  return str;
}
export {
  getCurrentDate,
  setCacheV1,
  getCacheV1,
  removeCacheV1,
  formatNumber,
  formatTimeFromTimestamp,
  toPercentageDecimal,
  isYesterday,
  getRandomIntInclusive,
  getRandomFloatInclusive,
  getRandomDigits,
  add,
  isIOSDevice,
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  isSupportedVersion,
  addCommasToNumber,
  appHapticFeedback,
  appHapticFeedbackSoft,
  openUrl,
  setCacheV2,
  getCacheV2,
  removeCacheV2,
  toastSuccess,
  toastFail,
  truncateString,
  _twa_encode,
  preloadImage,
  processMinerData,
  calculateClaimAmount,
  formatTimestamp,
  delayAwait,
  isMobileDevice,
  isUserInWhitelist,
  checkPaymentStatus,
  DecimalUtils,
  base62Encode,
  readClipboardText,
  addressFun,
  getCoinPrice,
  getUrl,
  _twa_decode,
  trimTrailingZeros,
};
